import { resolveService } from "@services/service-resolver";
import { realAuthService } from "./auth.service";
import { mockAuthService } from "./auth.mock-service";
import type { IAuthService } from "../types";

export const authService: IAuthService = resolveService(
  realAuthService,
  mockAuthService,
);
